<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $t("alarm.start_date_filter") }}
        </label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:s',
            time_24hr: true,
          }"
          :value="startDatetime"
          @on-change="(selectedDates, val) => $emit('update:startDatetime', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">
          {{ $t("alarm.end_date_filter") }}
        </label>
        <flat-pickr
          class="form-control"
          :config="{
            enableTime: true,
            dateFormat: 'Y-m-d H:i:s',
            time_24hr: true,
          }"
          :value="endDatetime"
          @on-change="(selectedDates, val) => $emit('update:endDatetime', val)"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">{{ $tc("hanwha_dvr.title", 2) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="dvrFilter"
          :options="dvrOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:dvrFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">Camera proxy</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="cameraFilter"
          :options="cameraOptions"
          class="w-100"
          multiple
          :disabled="!dvrFilter || dvrFilter.length === 0"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:cameraFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">Tipo de log</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="typeLogFilter"
          :options="typeLogOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:typeLogFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
      <b-col cols="6" class="mb-2">
        <label class="text-capitalize">Tipo de evento</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="typeFilter"
          :options="typeOptions"
          class="w-100"
          multiple
          :disabled="typeOptions.length === 0"
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:typeFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol, BButton } from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from "@/libs/popper-helper";
import flatPickr from "vue-flatpickr-component";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
    flatPickr,
  },
  props: {
    startDatetime: {
      type: String,
      default: null,
    },
    endDatetime: {
      type: String,
      default: null,
    },
    dvrOptions: {
      type: Array,
      default: null,
    },
    dvrFilter: {
      type: Array
    },
    typeLogOptions: {
      type: Array,
      default: () => [],
    },
    typeLogFilter: {
      type: Array,
      default: () => [],
    },
    typeOptions: {
      type: Array,
      default: () => [],
    },
    typeFilter: {
      type: Array,
      default: () => [],
    },
    cameraOptions: {
      type: Array,
      default: () => [],
    },
    cameraFilter: {
      type: Array,
      default: () => [],
    }
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    }
  }
};
</script>
